import React, {useEffect} from "react"
import { AnimatePresence, motion } from "framer-motion";

const Experience = () => {
    useEffect(() => {
        document.title = 'Awais Nisar | Experience';
      }, []);
return(
    <>
    <motion.div
        initial = {{opacity: 0}} 
        animate={{opacity:1}} 
        exit={{opacity:0}}
        >
        <div className="exper-intro">
        <div className="exper-intro-left">
        <>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1781.43 1756.09"
    className="test"
  >
    <title>career</title>
    <defs>
      <clipPath id="a">
        <circle
          cx={878.04}
          cy={878.04}
          r={878.04}
          style={{
            fill: "none",
            strokeWidth: 0,
          }}
        />
      </clipPath>
    </defs>
    <g
      style={{
        clipPath: "url(#a)",
      }}
    >
      <circle
        cx={878.04}
        cy={878.04}
        r={878.04}
        style={{
          fill: "#98c1d9",
          strokeWidth: 0,
        }}
      />
      <path
        d="M0 1116.41h1781.43v638.94H0z"
        style={{
          fill: "#3d5a80",
          strokeWidth: 0,
        }}
      />
      <path
        d="M294.06 154.05h232.63c0 38.51-31.27 69.78-69.78 69.78H294.06v-69.78Z"
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <ellipse
        cx={465.65}
        cy={163.81}
        rx={84.32}
        ry={60.02}
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <ellipse
        cx={349.13}
        cy={177.3}
        rx={81.17}
        ry={46.53}
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <circle
        cx={294.06}
        cy={213.83}
        r={10}
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <path
        d="M1063.44 242.12h232.63c0 38.51-31.27 69.78-69.78 69.78h-162.85v-69.78Z"
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <ellipse
        cx={1235.03}
        cy={251.88}
        rx={84.32}
        ry={60.02}
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <ellipse
        cx={1118.51}
        cy={265.37}
        rx={81.17}
        ry={46.53}
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <circle
        cx={1063.44}
        cy={301.9}
        r={10}
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <circle
        cx={1049.27}
        cy={195.08}
        r={10}
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <path
        d="M777.9 55.1h232.63c0 38.51-31.27 69.78-69.78 69.78H777.9V55.1Z"
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <ellipse
        cx={949.49}
        cy={64.85}
        rx={84.32}
        ry={60.02}
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <ellipse
        cx={832.97}
        cy={78.35}
        rx={81.17}
        ry={46.53}
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <circle
        cx={777.9}
        cy={114.88}
        r={10}
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <path
        d="M161.3 577.32h175.9v.67c0 29.48-23.94 53.42-53.42 53.42H161.31v-54.09Z"
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <ellipse
        cx={291.05}
        cy={584.88}
        rx={63.75}
        ry={46.53}
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <ellipse
        cx={202.94}
        cy={595.34}
        rx={61.38}
        ry={36.07}
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <ellipse
        cx={161.3}
        cy={623.66}
        rx={7.56}
        ry={7.75}
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <path
        d="M1419.06 569.76h175.9v.67c0 29.48-23.94 53.42-53.42 53.42h-122.47v-54.09Z"
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <ellipse
        cx={1548.8}
        cy={577.32}
        rx={63.75}
        ry={46.53}
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <ellipse
        cx={1460.7}
        cy={587.78}
        rx={61.38}
        ry={36.07}
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <ellipse
        cx={1419.06}
        cy={616.1}
        rx={7.56}
        ry={7.75}
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <path
        d="M796.27 562.19h175.9v.67c0 29.48-23.94 53.42-53.42 53.42H796.28v-54.09Z"
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <ellipse
        cx={926.01}
        cy={569.76}
        rx={63.75}
        ry={46.53}
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <ellipse
        cx={837.91}
        cy={580.22}
        rx={61.38}
        ry={36.07}
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <ellipse
        cx={796.27}
        cy={608.53}
        rx={7.56}
        ry={7.75}
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <path
        d="M1493.68 357.96h175.9v.67c0 29.48-23.94 53.42-53.42 53.42h-122.47v-54.09Z"
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <ellipse
        cx={1623.42}
        cy={365.53}
        rx={63.75}
        ry={46.53}
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <ellipse
        cx={1535.32}
        cy={375.99}
        rx={61.38}
        ry={36.07}
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <ellipse
        cx={1493.68}
        cy={404.3}
        rx={7.56}
        ry={7.75}
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <path
        d="M100.84 388.99h175.9v.67c0 29.48-23.94 53.42-53.42 53.42H100.85v-54.09Z"
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <ellipse
        cx={230.58}
        cy={396.55}
        rx={63.75}
        ry={46.53}
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <ellipse
        cx={142.48}
        cy={407.01}
        rx={61.38}
        ry={36.07}
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
      <ellipse
        cx={100.84}
        cy={435.33}
        rx={7.56}
        ry={7.75}
        style={{
          fill: "#fff",
          strokeWidth: 0,
        }}
      />
    </g>
    <path
      d="M531.45 806.19h304.58v193.52H531.45z"
      style={{
        fill: "#042642",
        strokeWidth: 0,
      }}
    />
    <rect
      width={60.17}
      height={44}
      x={685.95}
      y={776.62}
      rx={10.14}
      ry={10.14}
      style={{
        fill: "none",
        stroke: "#042642",
        strokeMiterlimit: 10,
        strokeWidth: 10,
      }}
    />
    <path
      d="M738.72 791.41h14.24v19.37h-14.24z"
      style={{
        fill: "#031f33",
        strokeWidth: 0,
      }}
    />
    <path
      d="M836.04 887.23c-26.62 13.47-80.79 36.45-152.79 36.35-71.44-.1-125.21-22.89-151.8-36.35v-81.04h304.58v81.04Z"
      style={{
        fill: "#0b2d44",
        strokeWidth: 0,
      }}
    />
    <path
      d="M875.21 758.05c-6.9.08-12.73 1.15-17.11 2.28l-7.98-3.88-18.7 31.93c2.22 3.3 5.23 7.68 8.9 12.77 5.4 7.5 8.2 11.17 10.95 13.68 9.26 8.48 21.21 9.78 24.86 10.04 2.38.16 25.25 1.41 35.1-14.52 3.22-5.2 3.96-10.48 4.13-13.76 3.73-1.44 7.45-2.89 11.18-4.33-4.64-12.47-9.28-24.94-13.91-37.41-6.54 1.75-13.08 3.5-19.61 5.25a71.092 71.092 0 0 0-17.79-2.05"
      style={{
        fill: "#e8b897",
        strokeWidth: 0,
      }}
    />
    <path
      d="M911.22 810.36c2.1-3.48 3.13-7.31 3.21-7.6.61-2.38.84-4.52.92-6.16 3.73-1.44 7.45-2.89 11.18-4.33-4.64-12.47-9.28-24.94-13.91-37.41-6.54 1.75-13.08 3.5-19.61 5.25 9.33 6.62 12.39 13.98 13.47 17.26 5.46 16.56-5.06 34.25-6.68 36.98-2.79 4.69-5.35 7.32-4.64 8.1 1.24 1.36 11.27-4.14 16.07-12.09Z"
      style={{
        fill: "#ffede1",
        strokeWidth: 0,
      }}
    />
    <path
      d="M1261.72 401.71c2.47 22.96 3.24 59.3-10.94 99.29-13.17 37.14-33.08 60.05-72.36 104.34-31.71 35.75-64.17 66.77-97.61 95.08-31.93 27.03-75.63 60.8-131.27 95.08-15.43-18.23-30.85-36.46-46.28-54.69 65.24-52.85 114.9-95.59 142.21-120.33 7.29-6.61 20.59-18.85 31.98-38.71 11.77-20.53 15.27-38.33 17.57-48.82 7.14-32.57 22.45-102.42 64.05-148.92 8.88-9.93 23.63-24 46.82-36.78 8.36 4.28 19.45 11.08 30.6 21.63a132.21 132.21 0 0 1 25.24 32.82Z"
      style={{
        fill: "#282828",
        strokeWidth: 0,
      }}
    />
    <path
      d="M664.18 249.75c.5 6.44.54 14.47-.79 23.56a106.638 106.638 0 0 1-9.5 30.99c4.25 4.26 16.48 15.42 36.15 19.08 19.51 3.64 34.84-2.24 40.35-4.67 1.14-9.15 2.29-18.3 3.43-27.45 5.66.71 11.48 1.34 17.46 1.88 12.01 1.07 23.52 1.66 34.44 1.86 9.56-6.36 11.72-11.57 11.81-15.26.05-2.3-1.13-4.69-1.13-11.96 0 0-.19-3.2-.24-6.42-.19-10.93 2.11-26.04 2.49-28.48h10.51c1.28-.76 2.87-1.99 3.36-3.88 1.15-4.41-4.69-8.61-9.71-15.16-2.84-3.7-6.26-9.27-8.66-17.34-3.54-20.16-7.08-40.33-10.63-60.49l-50.1 3.27c-1.45.18-16.09 2.24-22.94 15.34-4.33 8.28-3.1 16.31-2.57 18.99.54 11.31 1.09 22.62 1.63 33.92-.24 2.43-1.84 4.47-4 5.12-2.67.81-5.77-.63-7.03-3.48-.87-4.27-1.73-8.54-2.6-12.82-.59-.51-4.09-3.49-9.14-2.96-3.95.42-6.43 2.73-7.16 3.46l-1.13 30.51c.11 2.06.12 7.37-3.14 12.87-3.72 6.27-9.33 8.79-11.16 9.52Z"
      style={{
        fill: "#e8b897",
        strokeWidth: 0,
      }}
    />
    <path
      d="M733.62 292.73c-.17-.02-.41-.05-.71-.09-13.78-1.8-23.1-10.93-29.88-17.73-10.57-10.63-16.8-22.06-20.45-30.67"
      style={{
        fill: "none",
        stroke: "#d8ab8d",
        strokeMiterlimit: 10,
        strokeWidth: 3,
      }}
    />
    <path
      d="M664.33 251.88c-3.58-3.06-42.09-37.07-36.14-86.83 3.34-27.93 18.99-46.52 25.7-53.64 19.26-15.62 35.63-19.82 47.51-20.53 14.86-.89 26.31 3.46 42.39-2.57 6.81-2.55 12.27-6.16 16.49-9.65 3.13-2.59 7.67-2.48 10.62.32 6.74 6.39 16.74 18.65 17.21 35.66.25 9.19-2.36 16.65-4.57 21.38-18.65 1.56-37.31 3.12-55.96 4.67-4.27 1.6-10.5 4.72-14.65 10.97-4.31 6.5-4.05 12.86-4.12 27.84-.03 6.24-.13 15.67-.47 27.55-.08 2.96-1.78 5.7-4.48 6.9-1.43.64-2.41.57-3.1.3-4.62-1.84-.35-14.76-6.98-19.55-2.92-2.11-7.88-2.58-11.11-.05-2.61 2.04-3.03 5.55-3.24 7.74-1.66 16.96-.54 24.55-2.23 31.41-1.19 4.82-4.26 11.35-12.85 18.08Z"
      style={{
        fill: "#1e1a17",
        strokeWidth: 0,
      }}
    />
    <path
      d="m575.51 353.32-22.39 413.49 180.5 11.95 54.49-331.92-29.52-86.93L606 336.42"
      style={{
        fill: "#fff",
        stroke: "#efefef",
        strokeMiterlimit: 10,
      }}
    />
    <path
      d="M429.04 1627.5a151.55 151.55 0 0 0-3.14 22.93c-.53 8.89-.22 16.85.43 23.62h51.04v-5.97c10.01 2.52 20.95 4.73 32.76 6.32 31.6 4.26 59.53 2.8 81.8-.35v-11.4c-16.72-3.58-36.91-9.4-58.79-19.09a300.363 300.363 0 0 1-42.74-23.26l-61.35 7.2ZM619.06 1629.75a151.55 151.55 0 0 0-3.14 22.93c-.53 8.89-.22 16.85.43 23.62h51.04v-5.97c10.01 2.52 20.95 4.73 32.76 6.32 31.6 4.26 59.53 2.8 81.8-.35v-11.4c-16.72-3.58-36.91-9.4-58.79-19.09a300.363 300.363 0 0 1-42.74-23.26l-61.35 7.2Z"
      style={{
        fill: "#211406",
        strokeWidth: 0,
      }}
    />
    <path
      d="M617.32 777.37c-19.28 75.27-36.5 185.97-16.45 315.53 7.1 45.88 17.77 87.05 29.66 123.03-8.55 44.84-15.7 93.76-20.28 146.38-8.79 101.08-6 192.03 1.65 269.48 25.81-1.43 51.62-2.85 77.43-4.28 4.03-27.96 47.42-332.38 51.07-534.23.52-28.92 1.61-132.11-1.85-263.07-.68-25.55-1.38-46.65-1.88-60.85-39.78 2.67-79.56 5.35-119.34 8.02Z"
      style={{
        fill: "#282828",
        strokeWidth: 0,
      }}
    />
    <path
      d="M503.69 764.67c-15.83 68.2-29.45 155.72-29.06 257.65.29 75.21 8.14 141.75 18.33 197.37-18.95 43.8-38.12 98.23-51.5 162.15-20.45 97.69-20.14 182.89-14.78 245.66h77.01a7556.091 7556.091 0 0 0 98.78-457.59 7559.159 7559.159 0 0 0 62.44-400.1c-53.74-1.71-107.48-3.43-161.22-5.14Z"
      style={{
        fill: "#2d2d2d",
        strokeWidth: 0,
      }}
    />
    <path
      d="M550.28 751.96c-.84 4-1.68 8.01-2.53 12.01a429.047 429.047 0 0 0 96.83 13.29c36.28.81 67.56-3.11 92.08-7.91l.11-12.98c-25.2 4.81-57.38 8.68-94.69 7.69-36.23-.96-67.34-6.23-91.8-12.1Z"
      style={{
        strokeWidth: 0,
      }}
    />
    <path
      d="M492.95 935.19c-7.69-3.34-27.61-13.2-42.04-35.85-15.27-23.98-15.06-47.65-14.61-55.87a383.762 383.762 0 0 1 20.11-49.73c15.13-30.98 25.83-42.25 40.18-69.64 14.2-27.1 22.84-52.55 26.82-67.8 13.65-52.22-.04-89.2-5.15-128.46-5.35-41.09-3.45-101.29 31.94-180.58 13.94-2.57 30.79-6.84 49.21-14.14a262.199 262.199 0 0 0 48.93-25.66c1.7 6.96 4.67 15.84 10.1 25.24 9.97 17.3 23.14 27.56 31.13 32.82 4.37 26.01 6.76 61.44-2.52 100.97-14.32 60.96-45.02 83.11-80.74 161.42-14.37 31.51-13.68 37.31-36.52 104.56-16.28 47.93-41.28 117.56-76.84 202.71Z"
      style={{
        fill: "#282828",
        strokeWidth: 0,
      }}
    />
    <path
      d="M648.35 307.47c-2.6 9.94-5.19 19.89-7.79 29.83a178.68 178.68 0 0 1 11.72 40.28 178.17 178.17 0 0 1 1.61 46.44c9.56 3.61 19.13 7.23 28.69 10.84-10.21 4.95-20.42 9.91-30.63 14.86a569.37 569.37 0 0 1-7.44 50.47c-15.22 78.56-41.71 126.05-38.19 127.73 4.12 1.97 38.07-64.32 62.5-112.04 2.37-4.63 7.44-14.62 12.24-28.51 6.3-18.21 8.57-32.79 9.64-39.81 5.03-33.3 1.84-63.68-1.12-82.03a96.82 96.82 0 0 1-25.62-24.33 96.66 96.66 0 0 1-15.61-33.73Z"
      style={{
        fill: "#333",
        strokeWidth: 0,
      }}
    />
    <path
      d="M713.46 374.43c18.25 64.92 13.63 113.25 5.44 146.13-4.33 17.41-17.38 38.07-28.54 78.59-6.1 22.13-9.85 41.54-13.47 60.24-5.85 30.26-9.61 55.6-11.99 73.63 12.98 12.26 25.96 24.53 38.94 36.79 5.12-11.38 10.24-22.77 15.36-34.15.32-11.91 1.32-30.05 4.67-51.89 4.68-30.51 11.1-49.62 16.4-69.53 0 0 12.37-47.37 16.37-99.59 2.51-32.82 1.06-82.01-20.7-144.39-7.5 1.39-15 2.78-22.49 4.17Z"
      style={{
        fill: "#ee6c4d",
        strokeWidth: 0,
      }}
    />
    <path
      d="M494.37 401.71c-2.47 22.96-3.24 59.3 10.94 99.29 13.17 37.14 33.08 60.05 72.36 104.34 31.71 35.75 64.17 66.77 97.61 95.08 31.93 27.03 75.63 60.8 131.27 95.08 15.43-18.23 30.85-36.46 46.28-54.69-65.24-52.85-114.9-95.59-142.21-120.33-7.29-6.61-20.59-18.85-31.98-38.71-11.77-20.53-15.27-38.33-17.57-48.82-7.14-32.57-22.45-102.42-64.05-148.92-8.88-9.93-23.63-24-46.82-36.78a132.188 132.188 0 0 0-30.6 21.63 132.21 132.21 0 0 0-25.24 32.82Z"
      style={{
        fill: "#282828",
        strokeWidth: 0,
      }}
    />
    <path
      d="M744.43 336.42c-1.26 7.8-2.52 15.6-3.78 23.41 15.81 55.87 20.69 103.38 21.9 138.18 1.43 41.14-2.05 72.53-9.06 133.65-6.17 53.73-13.47 99.56-19.87 135.16 22.63-54.95 46.32-129.43 56.11-219.72 5.56-51.2 5.57-97.55 3.02-137.42-1.29-9.01-4.9-25.74-16.61-43.04-10.97-16.22-24.06-25.54-31.71-30.2Z"
      style={{
        fill: "#282828",
        strokeWidth: 0,
      }}
    />
    <path
      d="m716.8 339.56-11.94 10.79 8.6 24.08 22.49-4.17V357l-19.15-17.44z"
      style={{
        fill: "#ee6c4d",
        stroke: "#db6149",
        strokeMiterlimit: 10,
      }}
    />
    <path
      d="M653.96 304.36c-1.05 0-3.61.13-4.9 1.88-1.33 1.81-.61 4.39-.14 5.87 4.32 13.44 12.57 25.51 12.57 25.51 5.96 8.6 8.94 12.9 11.95 15.91a69.453 69.453 0 0 0 16.15 12c9.07-8.66 18.14-17.31 27.22-25.97 7.95 6.76 15.9 13.51 23.86 20.27 1.25-6.53 2.15-11.14 2.62-13.56 1.15-5.9 1.45-7.4 1.16-9.85-.67-5.61-3.67-9.47-4.76-10.84-3.11-3.9-6.75-5.86-8.79-6.77-6.06 2.61-19.46 7.39-36.52 5.22-21.96-2.78-35.89-15.27-40.39-19.67Z"
      style={{
        fill: "#fff",
        stroke: "#efefef",
        strokeMiterlimit: 10,
      }}
    />
    <path
      d="m809.83 791.62 12.51 12 37.32-49.01-11.69-8.05-38.14 45.06z"
      style={{
        fill: "#fff",
        strokeWidth: 0,
      }}
    />
    <path
      d="M1091.9 249.75c-.5 6.44-.54 14.47.79 23.56 1.91 13.15 5.97 23.67 9.5 30.99-4.25 4.26-16.48 15.42-36.15 19.08-19.51 3.64-34.84-2.24-40.35-4.67-1.14-9.15-2.29-18.3-3.43-27.45-5.66.71-11.48 1.34-17.46 1.88a489.419 489.419 0 0 1-34.44 1.86c-9.56-6.36-11.72-11.57-11.81-15.26-.05-2.3 1.13-4.69 1.13-11.96 0 0 .19-3.2.24-6.42.19-10.93-2.11-26.04-2.49-28.48h-10.51c-1.28-.76-2.87-1.99-3.36-3.88-1.15-4.41 4.69-8.61 9.71-15.16 2.84-3.7 6.26-9.27 8.66-17.34 3.54-20.16 7.08-40.33 10.63-60.49l50.1 3.27c1.45.18 16.09 2.24 22.94 15.34 4.33 8.28 3.1 16.31 2.57 18.99-.54 11.31-1.09 22.62-1.63 33.92.24 2.43 1.84 4.47 4 5.12 2.67.81 5.77-.63 7.03-3.48.87-4.27 1.73-8.54 2.6-12.82.59-.51 4.09-3.49 9.14-2.96 3.95.42 6.43 2.73 7.16 3.46l1.13 30.51c-.11 2.06-.12 7.37 3.14 12.87 3.72 6.27 9.33 8.79 11.16 9.52Z"
      style={{
        fill: "#ffede1",
        strokeWidth: 0,
      }}
    />
    <path
      d="M1022.47 292.73c.17-.02.41-.05.71-.09 13.78-1.8 23.1-10.93 29.88-17.73 10.57-10.63 16.8-22.06 20.45-30.67"
      style={{
        fill: "none",
        stroke: "#eadad0",
        strokeMiterlimit: 10,
      }}
    />
    <path
      d="M1091.76 251.88c3.58-3.06 42.09-37.07 36.14-86.83-3.34-27.93-18.99-46.52-25.7-53.64-19.26-15.62-35.63-19.82-47.51-20.53-14.86-.89-26.31 3.46-42.39-2.57-6.81-2.55-12.27-6.16-16.49-9.65-3.13-2.59-7.67-2.48-10.62.32-6.74 6.39-16.74 18.65-17.21 35.66-.25 9.19 2.36 16.65 4.57 21.38 18.65 1.56 37.31 3.12 55.96 4.67 4.27 1.6 10.5 4.72 14.65 10.97 4.31 6.5 4.05 12.86 4.12 27.84.03 6.24.13 15.67.47 27.55.08 2.96 1.78 5.7 4.48 6.9 1.43.64 2.41.57 3.1.3 4.62-1.84.35-14.76 6.98-19.55 2.92-2.11 7.88-2.58 11.11-.05 2.61 2.04 3.03 5.55 3.24 7.74 1.66 16.96.54 24.55 2.23 31.41 1.19 4.82 4.26 11.35 12.85 18.08Z"
      style={{
        fill: "#c96",
        strokeWidth: 0,
      }}
    />
    <path
      d="m1180.58 353.32 22.39 413.49-180.5 11.95-54.5-331.92 29.53-86.93 152.58-23.49"
      style={{
        fill: "#fff",
        stroke: "#efefef",
        strokeMiterlimit: 10,
      }}
    />
    <path
      d="M1327.05 1627.5a151.55 151.55 0 0 1 3.14 22.93c.53 8.89.22 16.85-.43 23.62h-51.04v-5.97a295.723 295.723 0 0 1-32.76 6.32c-31.6 4.26-59.53 2.8-81.8-.35v-11.4c16.72-3.58 36.91-9.4 58.79-19.09a300.363 300.363 0 0 0 42.74-23.26l61.35 7.2ZM1137.03 1629.75a151.55 151.55 0 0 1 3.14 22.93c.53 8.89.22 16.85-.43 23.62h-51.04v-5.97a295.723 295.723 0 0 1-32.76 6.32c-31.6 4.26-59.53 2.8-81.8-.35v-11.4c16.72-3.58 36.91-9.4 58.79-19.09a300.363 300.363 0 0 0 42.74-23.26l61.35 7.2Z"
      style={{
        fill: "#211406",
        strokeWidth: 0,
      }}
    />
    <path
      d="M1138.77 777.37c19.28 75.27 36.5 185.97 16.45 315.53-7.1 45.88-17.77 87.05-29.66 123.03 8.55 44.84 15.7 93.76 20.28 146.38 8.79 101.08 6 192.03-1.65 269.48-25.81-1.43-51.62-2.85-77.43-4.28-4.03-27.96-47.42-332.38-51.07-534.23-.52-28.92-1.61-132.11 1.85-263.07.68-25.55 1.38-46.65 1.88-60.85 39.78 2.67 79.56 5.35 119.34 8.02Z"
      style={{
        fill: "#282828",
        strokeWidth: 0,
      }}
    />
    <path
      d="M1252.4 764.67c15.83 68.2 29.45 155.72 29.06 257.65-.29 75.21-8.14 141.75-18.33 197.37 18.95 43.8 38.12 98.23 51.5 162.15 20.45 97.69 20.14 182.89 14.78 245.66h-77.01a7556.091 7556.091 0 0 1-98.78-457.59 7559.159 7559.159 0 0 1-62.44-400.1c53.74-1.71 107.48-3.43 161.22-5.14Z"
      style={{
        fill: "#2d2d2d",
        strokeWidth: 0,
      }}
    />
    <path
      d="M1205.81 751.96c.84 4 1.68 8.01 2.53 12.01a429.047 429.047 0 0 1-96.83 13.29c-36.28.81-67.56-3.11-92.08-7.91-.04-4.33-.07-8.65-.11-12.98 25.2 4.81 57.38 8.68 94.69 7.69 36.23-.96 67.34-6.23 91.8-12.1Z"
      style={{
        strokeWidth: 0,
      }}
    />
    <path
      d="M1263.13 935.19c7.69-3.34 27.61-13.2 42.04-35.85 15.27-23.98 15.06-47.65 14.61-55.87a383.762 383.762 0 0 0-20.11-49.73c-15.13-30.98-25.83-42.25-40.18-69.64-14.2-27.1-22.84-52.55-26.82-67.8-13.65-52.22.04-89.2 5.15-128.46 5.35-41.09 3.45-101.29-31.94-180.58a262.942 262.942 0 0 1-49.21-14.14 262.199 262.199 0 0 1-48.93-25.66c-1.7 6.96-4.67 15.84-10.1 25.24-9.97 17.3-23.14 27.56-31.13 32.82-4.37 26.01-6.76 61.44 2.52 100.97 14.32 60.96 45.02 83.11 80.74 161.42 14.37 31.51 13.68 37.31 36.52 104.56 16.28 47.93 41.28 117.56 76.84 202.71Z"
      style={{
        fill: "#282828",
        strokeWidth: 0,
      }}
    />
    <path
      d="M1107.74 307.47c2.6 9.94 5.19 19.89 7.79 29.83a178.68 178.68 0 0 0-11.72 40.28 178.17 178.17 0 0 0-1.61 46.44c-9.56 3.61-19.13 7.23-28.69 10.84 10.21 4.95 20.42 9.91 30.63 14.86a569.37 569.37 0 0 0 7.44 50.47c15.22 78.56 41.71 126.05 38.19 127.73-4.12 1.97-38.07-64.32-62.5-112.04-2.37-4.63-7.44-14.62-12.24-28.51-6.3-18.21-8.57-32.79-9.64-39.81-5.03-33.3-1.84-63.68 1.12-82.03a96.82 96.82 0 0 0 25.62-24.33 96.66 96.66 0 0 0 15.61-33.73Z"
      style={{
        fill: "#333",
        strokeWidth: 0,
      }}
    />
    <path
      d="M1042.63 374.43c-18.25 64.92-13.63 113.25-5.44 146.13 4.33 17.41 17.38 38.07 28.54 78.59 6.1 22.13 9.85 41.54 13.47 60.24 5.85 30.26 9.61 55.6 11.99 73.63-12.98 12.26-25.96 24.53-38.94 36.79-5.12-11.38-10.24-22.77-15.36-34.15-.32-11.91-1.32-30.05-4.67-51.89-4.68-30.51-11.1-49.62-16.4-69.53 0 0-12.37-47.37-16.37-99.59-2.51-32.82-1.06-82.01 20.7-144.39 7.5 1.39 15 2.78 22.49 4.17Z"
      style={{
        fill: "#ee6c4d",
        strokeWidth: 0,
      }}
    />
    <path
      d="M1011.66 336.42c1.26 7.8 2.52 15.6 3.78 23.41-15.81 55.87-20.69 103.38-21.9 138.18-1.43 41.14 2.05 72.53 9.06 133.65 6.17 53.73 13.47 99.56 19.87 135.16-22.63-54.95-46.32-129.43-56.11-219.72-5.56-51.2-5.57-97.55-3.02-137.42 1.29-9.01 4.9-25.74 16.61-43.04 10.97-16.22 24.06-25.54 31.71-30.2Z"
      style={{
        fill: "#282828",
        strokeWidth: 0,
      }}
    />
    <path
      d="m1039.29 339.56 11.94 10.79-8.6 24.08-22.49-4.17V357l19.15-17.44z"
      style={{
        fill: "#ee6c4d",
        stroke: "#db6149",
        strokeMiterlimit: 10,
      }}
    />
    <path
      d="M1102.13 304.36c1.05 0 3.61.13 4.9 1.88 1.33 1.81.61 4.39.14 5.87-4.32 13.44-12.57 25.51-12.57 25.51-5.96 8.6-8.94 12.9-11.95 15.91a69.453 69.453 0 0 1-16.15 12c-9.07-8.66-18.14-17.31-27.22-25.97-7.95 6.76-15.9 13.51-23.86 20.27-1.25-6.53-2.15-11.14-2.62-13.56-1.15-5.9-1.45-7.4-1.16-9.85.67-5.61 3.67-9.47 4.76-10.84 3.11-3.9 6.75-5.86 8.79-6.77 6.06 2.61 19.46 7.39 36.52 5.22 21.96-2.78 35.89-15.27 40.39-19.67Z"
      style={{
        fill: "#fff",
        stroke: "#efefef",
        strokeMiterlimit: 10,
      }}
    />
    <path
      d="m946.25 791.62-12.51 12-37.31-49.01 11.69-8.05 38.13 45.06z"
      style={{
        fill: "#fff",
        strokeWidth: 0,
      }}
    />
    <path
      d="M1105.9 925.93h57.7v29.77h-57.7z"
      style={{
        fill: "none",
        stroke: "#563621",
        strokeMiterlimit: 10,
        strokeWidth: 10,
      }}
      transform="rotate(20.63 1134.606 940.63)"
    />
    <path
      d="M1146.8 858.51c-4.17 1.76-4.34 4.1-10.88 11.75-6.04 7.07-6.43 5.7-17.59 16.75-4.12 4.07-8.75 9.84-18.01 21.36-3.24 4.03-6.19 7.8-5.1 11.66.72 2.56 3.2 5.03 5.59 4.97 3.13-.07 4.46-4.91 8.7-11.19 3.73-5.52 11.2-14.34 14.29-13.05 3.74 1.56 1.33 18.02-.03 24.99-1.78 9.12-4.48 15.84-1.05 19.48 1.25 1.32 2.87 1.79 4.61 2.09 18.01 3.12 29.74-6.28 29.74-6.28 12.38-9.93 4.74-21.5 17.59-51.31 3.67-8.52 12.09-18.29 8.38-24.08-.72-1.12-1.92-2.17-13.82-4.82-17.91-3.98-21.02-2.92-22.42-2.33Z"
      style={{
        fill: "#ffede1",
        strokeWidth: 0,
      }}
    />
    <path
      d="m1195.16 860.04-3.76 16.92-58.23-20.1 5.27-13.19 56.72 16.37z"
      style={{
        fill: "#fff",
        strokeWidth: 0,
      }}
    />
    <path
      d="M1240 362.25c14.85 17.68 35.76 47.42 46.29 88.52 9.78 38.17 6.03 68.29-1.88 126.96-6.39 47.36-16.03 91.21-28 133.36-11.43 40.24-28.87 92.64-55.94 152.13-22.97-6.53-45.94-13.06-68.92-19.59 24.68-80.25 42.07-143.43 50.94-179.18 2.37-9.55 6.58-27.13 4.96-49.96-1.68-23.6-8.7-40.33-12.64-50.32-12.24-31.02-38.48-97.53-29.87-159.33 1.84-13.2 6.23-33.1 18.35-56.63 9.33-1.11 22.32-1.65 37.46.89 17.04 2.86 30.38 8.54 39.25 13.16Z"
      style={{
        fill: "#282828",
        strokeWidth: 0,
      }}
    />
    <path
      d="M1135.42 902.01c2.36 8.56 1.85 15 .89 19.36-.77 3.53-5.95 24.66-6.02 25.32l-.08.89c0 .06 0 .11-.01.15M1144.66 901.42c2.36 8.22 2.39 14.83 1.93 19.48 0 0-.58 5.83-7.77 26.26.02.19.03.39.05.58M1153.1 902.55c3.39 10.98 2.85 19.18 1.64 24.76-1.4 6.44-5.39 17.14-5.39 17.14.06.23.11.46.17.69"
      style={{
        fill: "none",
        stroke: "#eadad0",
        strokeMiterlimit: 10,
      }}
    />
    <path
      d="M1014.91 946.86h180.62v128.2h-180.62z"
      style={{
        fill: "#54321a",
        strokeWidth: 0,
      }}
      transform="rotate(20.63 1105.082 1010.771)"
    />
    <path
      d="m1072.38 1067.09-74.26-27.95 45.16-119.98 74.26 27.95c1.44 12.43 2.45 35.47-6.75 61.99-10.54 30.41-28.93 49.4-38.42 57.99Z"
      style={{
        fill: "#563621",
        strokeWidth: 0,
      }}
    />
  </svg>
</>

        </div>
        <div className="exper-intro-right">
          <h1>Experience</h1>
          <p className="exper-desc">I am passionate about the field of computer science. I eagerly learn new tools, staying current in this evolving field. Open to opportunities, I believe continuous learning is vital for success. Excited to contribute skills to challenging software applications.</p>
        </div>
        </div>
        <h2 className="subtitle">Work Experience</h2>
        <div className="box">
          <div className="job">
            <div className="job-leftright">
            <div className="job-left">
            <div className="job-left-logo">
              <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 300 300"
      className="company-logo"
    >
      <image
        transform="scale(1.5)"
        xlinkHref="data:image/png;base64,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"
      ></image>
    </svg>
              </div>
              <div className="job-left-box">
              <h3 className="position">App Developer Internship</h3>
              <p className="company">GoSign.AI</p>
            </div>
            </div>
            <div className="job-right">
            <p className="city">Toronto, ON</p>
              <p className="date">May 2024 - Current</p>
            </div>   
            </div>
            <p>During my internship as an app developer, I focused on improving the application in several key areas. I used AWS CDK to enhance cloud infrastructure and databases, ensuring smooth operation. Additionally, I set up API Gateway to manage services more effectively, facilitating seamless communication between them. With React Native, I refined the app's appearance and improved interactions for users. I worked closely with the team to ensure the app performed well, providing our users with a great experience.</p>
            <a href="https://www.gosign.ai" className="uni-web">Visit Website</a>
          </div>
        </div>
        <footer>
          <p> Made by Awais Nisar 👨🏻‍💻</p>
        </footer>
        </motion.div>
    </>
    )
}

export default Experience;
